<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-5 col-md-12 mb-4">
                      <h2>Bid Wanted</h2>
                      <div class="ims-tab ml-0">
                         <router-link to="/bidaccumulator/admin">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baAdminAllHoldings' }" >
                            Holdings
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/admin/authorize">
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baAdminAuthorize' }" >
                            Operator Sent
                          </button>
                        </router-link>
                        <router-link to="/bidaccumulator/admin/bidwanted" >
                          <button class="btn" v-bind:class="{ 'active': $route.name =='baAdminBidwanted' }" >
                            Bid Wanted
                          </button>
                        </router-link>
                      </div>
                    </div>
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div> 
        
</template>
<script>

export default {
  name: "baholdings",
  components : {

  },
  watch:{
    $route (){
      this.isOperator = window.location.pathname.includes('operator')
    }
  } , 
  data() {
    return {
      isOperator : window.location.pathname.includes('operator')
    };
  },
  methods: {

  },
  mounted() {
  }
};
</script>